module.exports = __webpack_public_path__ + "d7e10066e93c1dde0185877a7764e066.svg";